import { z } from 'zod';
import { mediaSchema } from '../media.js';
import { conditionsSchema, hintsSchema } from '../schema.v2.descriptor.js';

const baseTaskSchema = z.object({
  id: z.string(),
  question: z.string().nullish().default(""),
  introduction: z.array(mediaSchema).default([]),
  hints: hintsSchema,
  conditions: conditionsSchema.nullish().default(null)
});

export { baseTaskSchema };
//# sourceMappingURL=schema.base.js.map
